import { render, staticRenderFns } from "./projectProgress.vue?vue&type=template&id=0134cda6&"
import script from "./projectProgress.vue?vue&type=script&lang=js&"
export * from "./projectProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports